var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Register extends Component {
    constructor() {
        super('Register', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('body').on('keyup', '.gfield--type-text input, .gfield--type-textarea textarea', (event, input) => {
                this.processField(input);
            });
            setTimeout(() => {
                if (typeof jQuery === 'undefined')
                    return;
                jQuery(document).bind('gform_post_render', () => {
                    if ($('.gform_confirmation_message').length > 0) {
                        $('.module-register .component-shape-column__link').remove();
                    }
                    else {
                        $('.gfield--type-text input, .gfield--type-textarea textarea').each((input) => {
                            this.processField(input);
                        });
                    }
                });
            }, 1000);
            this.success();
        });
    }
    processField(field) {
        if (field.val() !== '') {
            field.parents('.gfield').addClass('has-value');
        }
        else {
            field.parents('.gfield').removeClass('has-value');
        }
    }
}
